module.exports = __webpack_public_path__ + "static/img/feoug.2c7c0568.jpg";